import api from './api';

export interface SuggestedTopic {
  name: string;
  emoji: string | null;
  tasks: string[];
}

export interface OnboardingTopicTask {
  title: string;
}

export interface OnboardingTopicSelection {
  name: string;
  emoji: string | null;
  tasks: OnboardingTopicTask[];
}

export interface OnboardingPlannerCreate {
  name: string;
  color: string | null;
}

export interface OnboardingSubmitData {
  wedding_title: string | null;
  wedding_date: string | null;
  wedding_venue: string | null;
  planners: OnboardingPlannerCreate[];
  topics: OnboardingTopicSelection[];
}

export interface OnboardingResult {
  topics_created: number;
  tasks_created: number;
  planners_created: number;
}

export const getSuggestions = () => api.get<SuggestedTopic[]>('/onboarding/suggestions');
export const completeOnboarding = (data: OnboardingSubmitData) =>
  api.post<OnboardingResult>('/onboarding/complete', data);
